import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { Equipment, Location } from '../../../core/interfaces';
import { EquipmentsApi } from '../services/api/equipments.api';
import { DialogEquipmentComponent, EquipmentDialogData, EquipmentDialogResult } from './dialog-equipments.component';
import { DialogEquipmentServiceGet, DialogEquipmentServiceOpen } from './dialog-equipments.types';

@Injectable({
  providedIn: 'root'
})
export class DialogEquipmentService {

  constructor(
    private readonly matDialog: MatDialog,
    private readonly equipmentsApi: EquipmentsApi,
    private readonly fuseProgressBarService: FuseProgressBarService,
    private readonly authenticationService: AuthenticationService,
  ) {}

  public async open(params: DialogEquipmentServiceOpen): Promise<EquipmentDialogResult> {
    const { location, equipmentId, selectedTab, disableEditLocation } = params;

    const equipment = await this.getEquipment({ equipmentId, location });
    return this.matDialog.open<DialogEquipmentComponent, EquipmentDialogData, EquipmentDialogResult>(DialogEquipmentComponent, {
      panelClass: ['dialog-equipment'],
      autoFocus: false,
      data: {
        equipment,
        selectedTab,
        disableEditLocation,
      }
    }).afterClosed()
      .toPromise();
  }

  async getEquipment(params: DialogEquipmentServiceGet): Promise<Equipment> {
    this.fuseProgressBarService.show();

    const { equipmentId, location } = params;
    const result = equipmentId ? this.fetchEquipment(equipmentId) : {
      name: '',
      archived: false,
      location: location || null,
      type: null,
      customFields: [],
    };

    this.fuseProgressBarService.hide();
    return result;
  }

  private async fetchEquipment(equipmentId: string): Promise<Equipment | undefined> {
    return this.equipmentsApi.getEquipmentWithWarrantiesById(equipmentId);
  }
}
